export const EXPLORE_UNKNOWN_STRATEGY_STORAGE_KEY = 'selectedExploreUnknownStrategy';

function requireLocalStorage() {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    throw new Error('exploreUnknownStrategyStorage: localStorage is required');
  }
  return window.localStorage;
}

/**
 * @returns {string|null}
 */
export function readExploreUnknownStoredStrategyIdOrNull() {
  const storage = requireLocalStorage();
  try {
    const raw = storage.getItem(EXPLORE_UNKNOWN_STRATEGY_STORAGE_KEY);
    if (raw == null || raw === '') {
      return null;
    }
    return String(raw);
  } catch (err) {
    throw new Error(`exploreUnknownStrategyStorage: localStorage read failed (${err?.message ?? err})`);
  }
}

/**
 * @param {string|number} strategyId
 */
export function writeExploreUnknownStoredStrategyId(strategyId) {
  if (strategyId == null || strategyId === '') {
    throw new Error('exploreUnknownStrategyStorage: strategyId is required');
  }
  const storage = requireLocalStorage();
  try {
    storage.setItem(EXPLORE_UNKNOWN_STRATEGY_STORAGE_KEY, String(strategyId));
  } catch (err) {
    throw new Error(`exploreUnknownStrategyStorage: localStorage write failed (${err?.message ?? err})`);
  }
}

export function clearExploreUnknownStoredStrategyId() {
  const storage = requireLocalStorage();
  try {
    storage.removeItem(EXPLORE_UNKNOWN_STRATEGY_STORAGE_KEY);
  } catch (err) {
    throw new Error(`exploreUnknownStrategyStorage: localStorage remove failed (${err?.message ?? err})`);
  }
}

/**
 * Restore the portal start-screen strategy from current selection or localStorage.
 * Clears stale storage when the saved strategy is no longer in the player's list.
 *
 * @param {string} selectedStrategyId
 * @param {Array<{ id?: number|string }>} strategies
 * @returns {string}
 */
export function resolveExploreUnknownStartScreenStrategyId(selectedStrategyId, strategies) {
  if (!Array.isArray(strategies)) {
    throw new Error('exploreUnknownStrategyStorage: strategies array is required');
  }
  const listedIds = new Set(
    strategies
      .filter((strategy) => strategy?.id != null)
      .map((strategy) => String(strategy.id))
  );
  const current = selectedStrategyId ? String(selectedStrategyId) : '';
  if (current && listedIds.has(current)) {
    return current;
  }
  const stored = readExploreUnknownStoredStrategyIdOrNull();
  if (stored == null) {
    return current;
  }
  if (!listedIds.has(stored)) {
    clearExploreUnknownStoredStrategyId();
    return current;
  }
  return stored;
}
